import { IstatCustomer } from '@h5s/entities';

export class TableIstatCustomer extends IstatCustomer {
  get city(): string | null {
    return this.customerData.city;
  }

  get guestsNumber(): number {
    return this.relatives?.length + 1 || 0;
  }

  constructor(init?: Partial<TableIstatCustomer>) {
    super(init);
  }
}
